import { fetchIncomeStatementSummaryAPI } from "../../../infrastructure/api/transactions";

export const fetchIncomeStatementSummary = async (
  period: string,
  accessToken: string,
) => {
  try {
    return await fetchIncomeStatementSummaryAPI(period, accessToken);
  } catch (error) {
    console.error("Error fetching financial data:", error);
    throw error;
  }
};
